import React from "react";
import { Link } from "react-router-dom";
import { BookmarkCheck, ArrowRight } from "lucide-react";
import { Button } from "components/ui/button";

const ENTITY_CONFIG = {
  institutions: {
    title: "No saved institution searches",
    desc: "Save search results while exploring institutions to compare cohorts, metrics, and export data.",
    link: "/explore/institutions",
    ctaLabel: "Explore Institutions",
  },
  researchers: {
    title: "No saved researcher searches",
    desc: "Save search queries while exploring researchers to monitor cohorts, h-index distributions, and export profiles.",
    link: "/explore/faculties",
    ctaLabel: "Explore Researchers",
  },
  units: {
    title: "No saved unit searches",
    desc: "Save search results while exploring units to track academic departments, faculty volume, and publication output.",
    link: "/explore/units",
    ctaLabel: "Explore Units",
  },
  venues: {
    title: "No saved venue searches",
    desc: "Save conference and journal searches to analyze publication performance, citation counts, and top authors.",
    link: "/explore/venues",
    ctaLabel: "Explore Venues",
  },
};

const SavedSearchEmptyState = ({ entityType = "institutions" }) => {
  const config = ENTITY_CONFIG[entityType] || ENTITY_CONFIG.institutions;

  return (
    <div className="flex flex-col items-center justify-center text-center p-12 sm:p-16 bg-white border border-dashed border-gray-300 rounded-xl flex-1 min-h-[480px] my-2 shadow-2xs">
      {/* Icon */}
      <div className="flex items-center justify-center w-16 h-16 rounded-2xl bg-slate-100 mb-6 border border-slate-200/60 shadow-2xs text-slate-500">
        <BookmarkCheck size={28} className="stroke-[1.75]" />
      </div>

      {/* Title & Description & CTA */}
      <div className="flex flex-col items-center gap-3.5 max-w-md w-full mx-auto">
        <h3 className="text-lg font-semibold text-gray-900 tracking-tight">
          {config.title}
        </h3>
        <p className="text-sm text-gray-500 leading-relaxed max-w-[420px] mx-auto">
          {config.desc}
        </p>

        {/* Action Button */}
        <div className="pt-2.5">
          <Button
            asChild
            size="sm"
            className="h-9 px-5 gap-2 bg-explore hover:bg-explore/90 text-white font-medium text-xs rounded-md shadow-xs transition-all cursor-pointer"
          >
            <Link to={config.link}>
              {config.ctaLabel}
              <ArrowRight size={14} />
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SavedSearchEmptyState;
